<script>

import useVuelidate from "@vuelidate/core";
import {helpers, required} from "@vuelidate/validators";
import Swal from "sweetalert2";
import moment from "moment";

export default {
  setup() {
    return { v$: useVuelidate() };
  },
  components: {

  },
  props: {
    tiposoperaList: {
      type: Array,
      default: function () {
        return [];
      },
    }
  },
  validations: {
    regSelecionado :{
      descricao: {
        required: helpers.withMessage("Campo descrição obrigatório, favor preencher.", required),
      },
      status: {
        required: helpers.withMessage("Campo status obrigatório, favor preencher.", required),
      },
      codigo: {
        required: helpers.withMessage("Campo código obrigatório, favor preencher.", required),
      },
    }
  },
  mounted() {
    // console.log('mounted tiposopera-table_0')
    // console.log(this.updating)
  },
  methods: {

    nomeStatus(strEntr){
      let result = 'Não Definido'
      switch (strEntr) {
        case 'A':
          result = 'Ativo'
          break
        default:
          result = 'Inativo'
          break
      }
      return result
    },

    detalhes(idData){
      console.log('editar: ' + idData)
      this.showModal = true
      this.regSelecionado = this.tiposoperaList.find((reg) => reg.id === idData);
      console.log('regSelecionado: ')
      console.log(this.regSelecionado)
    },

    editar(idData){
      console.log('detalhes_0: ' + idData)
      this.$router.push(`/tipoopera/editar/${idData}`);
    },

    deletar(idData){
      console.log('deletar: ' + idData)
      Swal.fire({
        position: "center",
        icon: "question",
        title: "Exclusão de Registro",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,

      }).then(result => {
        if (result.value) {
          this.$emit('deletareg', idData)
        }
      })
    },

    formSubmit() {
      console.log('formSubmit_0')
      this.submitted = true
      this.v$.$touch()
      if (this.v$.$invalid) {
        return;
      } else {
        console.log('formSubmit_validado')
        this.showModal = false
        this.$emit('alterareg', this.regSelecionado)
      }
      this.submitted = false
    },

    setCriarNova: function() {
      this.regSelecionado = {}
      this.submitted = false
      this.showModal = true

    },

    formatDecimal(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if(value){
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 2});
      }
      return 0.00;
    },

    formatDateTime(value) {
      // console.log('value formatDate')
      // console.log(value)
      // console.log(moment())
      const format = "DD/MM/YYYY HH:mm:ss"
      var date = new Date(value);
      let dateTime = moment(date).format(format);
      // console.log(dateTime1)
      return dateTime
    },

  },
  data() {
    return {
      regSelecionado: {},
      submitted: false,
      showModal: false,
    };
  },
};
</script>

<template>
  <div class="table-responsive mb-0">
    <table class="table align-middle table-nowrap" v-if="tiposoperaList">
      <thead class="table-light">
      <tr>

        <th class="align-middle">ID</th>
        <th class="align-middle">Código</th>
        <th class="align-middle">Descrição</th>
        <th class="align-middle">Filtro Tabela</th>
        <th class="align-middle">Filtro Operação</th>
        <th class="align-middle">Último Pedido</th>
        <th class="align-middle text-end">Quantidade Mínima</th>
        <th class="align-middle text-end">Valor Mínimo</th>
        <th class="align-middle">Status</th>
        <th class="align-middle">Ações</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="data in tiposoperaList" :key="data.id">
        <td>
          <a href="javascript: void(0);" class="text-body fw-bold" @click="detalhes(data.id)">{{
              data.id
            }}</a>
        </td>
        <td>{{ data.codigo }} </td>
        <td>{{ data.descricao }} </td>
        <td>{{ data.telefone }} </td>
        <td> </td>
        <td>{{ formatDateTime(data.created_at) }} </td>
        <td class="text-end">{{ formatDecimal(data.qtdmin) }} </td>
        <td class="text-end">{{ formatDecimal(data.valormin) }} </td>

        <td>
              <span
                  class="badge badge-pill badge-soft-success font-size-11"
                  :class="data.status === 'A' ? 'badge-soft-success' : 'badge-soft-danger'">
                {{ nomeStatus(data.status)  }}
              </span>
        </td>

        <td>
          <div class="button-items">

            <b-button variant="outline-success" @click="detalhes(data.id)">
              <i class="mdi mdi-eye d-block font-size-16"></i>
            </b-button>

            <b-button variant="outline-warning" @click="editar(data.id)">
              <i class="mdi mdi-pencil d-block font-size-16"></i>
            </b-button>

            <b-button variant="outline-danger" @click="deletar(data.id)" :disabled="data.email === 'admin@admin.com.br'">
              <i class="mdi mdi-trash-can d-block font-size-16"></i>
            </b-button>

          </div>
        </td>



      </tr>
      </tbody>
    </table>

    <b-modal :title="`Detalhes Tipo de Operação (${ regSelecionado.id })`" v-model="showModal" hide-footer>
      <form @submit.prevent="formSubmit">
        <div class="row">

          <div class="col-12">
            <div class="mb-3">
              <label for="descricao">Descrição</label>
              <input
                  id="descricao"
                  v-model="regSelecionado.descricao"
                  type="text"
                  class="form-control"
                  :disabled="true"
                  placeholder="Inserir descrição"/>
            </div>
          </div>

          <div class="col-6">
            <div class="mb-3">
              <label for="codigo">Código</label>
              <input
                  id="codigo"
                  v-model="regSelecionado.codigo"
                  type="text"
                  class="form-control"
                  :disabled="true"
                  placeholder="Inserir código"/>
            </div>
          </div>

          <div class="col-6">
            <div class="mb-3">
              <label for="cfopint">CFOP Interna</label>
              <input
                  id="cfopint"
                  v-model="regSelecionado.cfopint"
                  type="text"
                  class="form-control"

                  placeholder="CFOP Interna"/>
            </div>
          </div>

          <div class="col-6">
            <div class="mb-3">
              <label for="cfopext">CFOP Externa</label>
              <input
                  id="cfopext"
                  v-model="regSelecionado.cfopext"
                  type="text"
                  class="form-control"

                  placeholder="CFOP Externa"/>
            </div>
          </div>

          <div class="col-6">
            <div class="mb-3">
              <label for="cst">CST</label>
              <input
                  id="cst"
                  v-model="regSelecionado.cst"
                  type="text"
                  class="form-control"

                  placeholder="CST"/>
            </div>
          </div>



          <div class="col-6">
            <div class="mb-3">
              <label for="selectStatus">Status</label>
              <b-form-select
                  id="selectStatus"
                  v-model="regSelecionado.status"
                  :disabled="true"
                  class="mb-3 form-select form-control">
                <b-form-select-option value="A">
                  Ativo
                </b-form-select-option>
                <b-form-select-option value="I">
                  Inativo
                </b-form-select-option>
                <b-form-select-option value="L">
                  Análise
                </b-form-select-option>
              </b-form-select>


            </div>
          </div>


        </div>

        <div class="text-end mt-3">

          <b-button variant="light" @click="showModal = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Fechar
          </b-button>

          <b-button variant="success" class="ms-1" @click="formSubmit">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>

        </div>

      </form>

    </b-modal>
  </div>

</template>
